import AirtableTable from "../AirtableTable";
import { BaseTableModel } from "../models/base";
import { airtableFormulas } from "../formulas";

export const responsesTableId = "tblIm52skzbPQOK29";

export const responseFieldIds = {
  name: "fld8Tp4vsYAdnDcsA",
  responderType: "flduklKXfwQcPFCpj",
  status: "fldTcGGBWprVhUSVz",
  date1: "fld3BEQqMC7zcf6UD",
  artistDecision: "fldgDAfP98tVX5Kfb",
  notes: "fldvqoyUMCZjj3EQ0",
  date2: "flduwgHRgw45v5Aen",
  date3: "fld66MeptZ44Xekh9",
  proposedDate4: "fldRc5fIiokCF7dKI",
  date1Notes: "fldn3TyrhwO2Kq98x",
  date2Notes: "fldZTDZKPLq8lQPrg",
  date3Notes: "fld6prSxMygWPqghS",
  date4Notes: "fldSUiz7qNSNeqwcq",
  alternateProposedTime: "fldeje7RrBH8JkAa8",
  bookings: "fldSKPr71H0voAY4C"
};

export const responseFieldNames = {
  name: "Name",
  responderType: "Responder Type",
  status: "Status",
  date1: "Date 1",
  artistDecision: "Artist Decision",
  notes: "Notes",
  date2: "Date 2",
  date3: "Date 3",
  proposedDate4: "Proposed Date 4",
  date1Notes: "Date 1 Notes",
  date2Notes: "Date 2 Notes",
  date3Notes: "Date 3 Notes",
  date4Notes: "Date 4 Notes",
  alternateProposedTime: "Alternate Proposed Time",
  bookings: "Bookings"
};

export class ResponsesTable extends AirtableTable<BaseTableModel> {
  constructor(instance: any) {
    super(instance, responsesTableId);
    this.returnFieldsByFieldId = false;

    this.fields = [
      responseFieldIds.name,
      responseFieldIds.responderType,
      responseFieldIds.status,
      responseFieldIds.date1,
      responseFieldIds.artistDecision,
      responseFieldIds.notes,
      responseFieldIds.date2,
      responseFieldIds.date3,
      responseFieldIds.proposedDate4,
      responseFieldIds.date1Notes,
      responseFieldIds.date2Notes,
      responseFieldIds.date3Notes,
      responseFieldIds.date4Notes,
      responseFieldIds.alternateProposedTime,
      responseFieldIds.bookings
    ];
  }

  getByBookingIdFromName = async (bookingId: string) => {
    const normalizedBookingId = bookingId?.trim();
    if (!normalizedBookingId) return [];

    return this.list({
      filterByFormula: airtableFormulas.responses.byBookingIdInName(normalizedBookingId)
    }, undefined, true);
  }
}
